import { FC } from 'react';
import styles from './index.module.less';
import { IEgg } from '@pro/common/EggHunt/interface';
import Image from '@base/lib/ThemeImage';
import { get375CssValue } from 'base/utils/dom-size';
import { LazyLoad } from '@base/lib/LazyLoad';

type IEggProps = {
    egg: IEgg;
    onClick: () => void;
};

export const Egg: FC<IEggProps> = props => {
    const { egg, onClick } = props;

    const left = get375CssValue(Math.max(0, egg.x - (egg.width / 2)));
    const top = get375CssValue(Math.max(0, egg.y - (egg.height / 2)));

    return (
        <LazyLoad offset={0} className={'absolute'} style={{ top, left }}>
            <Image
                className={styles.egg}
                src={egg.src}
                width={egg.width}
                height={egg.height}
                background={false}
                fixed
                absolute
                pure
                style={{ top, left }}
                onClick={onClick}
                lazy={false}
            />
        </LazyLoad>
    )
};
